import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import styled from "styled-components";
import { margin } from "styled-system";
import Link from "./Link";
var StyledButton = styled(Link).withConfig({
  displayName: "ButtonLink__StyledButton",
  componentId: "sc-8betkf-0"
})(["text-decoration:none;display:inline-block;white-space:nowrap;padding:0.5rem 0.75rem;font-size:1rem;border-radius:0.25em;text-align:center;", ""], margin);
var Primary = styled(StyledButton).withConfig({
  displayName: "ButtonLink__Primary",
  componentId: "sc-8betkf-1"
})(["background-color:", ";color:", " !important;border:1px solid transparent;&:hover{background-color:", ";box-shadow:", ";}&:active{background-color:", ";}"], function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.buttonColor;
}, function (props) {
  return props.theme.colors.primaryHover;
}, function (props) {
  return props.theme.colors.cardBoxShadow;
}, function (props) {
  return props.theme.colors.primaryActive;
});
var Secondary = styled(StyledButton).withConfig({
  displayName: "ButtonLink__Secondary",
  componentId: "sc-8betkf-2"
})(["color:", ";border:1px solid ", ";background-color:transparent;&:hover{color:", ";border:1px solid ", ";box-shadow:", ";}&:active{background-color:", ";}"], function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.cardBoxShadow;
}, function (props) {
  return props.theme.colors.secondaryButtonBackgroundActive;
});

var ButtonLink = function ButtonLink(_ref) {
  var to = _ref.to,
      isSecondary = _ref.isSecondary,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["to", "isSecondary", "children", "className"]);

  if (isSecondary) {
    return /*#__PURE__*/React.createElement(Secondary, Object.assign({
      to: to,
      hideArrow: true,
      className: className
    }, props), children);
  }

  return /*#__PURE__*/React.createElement(Primary, Object.assign({
    to: to,
    hideArrow: true,
    className: className
  }, props), children);
};

export default ButtonLink;